import React, { useEffect, useRef, useState } from "react";

const cellStyle = {
  width: '80px',
  padding: '8px',
  border: '1.5px solid black',

  verticalAlign: 'middle'
};

function TableRows_pur({
  rowsData,
  deleteTableRows,
  handleChange,
  itemName,
  GroupMaster,
  UnitMaster,
  IsStockIn,
  ItemMaster,
  GodownMaster,
  addTableRows,
  totalSecUnit,
  secUnitHeader
}) {
  const [focusIndex, setFocusIndex] = useState(null);
  const Code = useRef([]);
  const Groups = useRef([]);
  const Godowns = useRef([]);
  const Colors = useRef([]);
  const Items = useRef([]);
  const Units = useRef([]);
  const Qtys = useRef([]);
  const SecUnits = useRef([]);
  const Rates = useRef([]);
  const Mrps = useRef([]);
  const TaxNames = useRef([]);
  const Discs = useRef([]);
  const Amounts = useRef([]);
  const Adds = useRef([]);
  const Deletes = useRef([]);

 
  useEffect(() => {
    if (focusIndex !== null) {
      Code.current[focusIndex].focus();
      setFocusIndex(null); 
    }
  }, [rowsData, focusIndex]);

  const handleFocus = event => event.target.select();

  const onKeyPressHandler = (evnt, index) => {
    if (evnt.key === "Enter") {
      evnt.preventDefault();

      if (IsStockIn) {
        handler2("Deletes", evnt, index);
      } else {
        handler2("Rates", evnt, index);
      }
    }
  };
  const handler = (name, event, index) => {
    if (event.key === "Enter") {
      event.preventDefault();

      setTimeout(() => {
        switch (name) {
          case "Code":
            if (Code.current[index]) {
              Code.current[index].focus();
            }
            break;
            case "Items":
              if (Items.current[index]) {
                Items.current[index].focus();
              }
              break;
            case "Godowns":
              if (Godowns.current[index]) {
                Godowns.current[index].focus();
              }
              break;
            case "Colors":
              if (Colors.current[index]) {
                Colors.current[index].focus();
              }
              break;
          case "Groups":
            if (Groups.current[index]) {
              Groups.current[index].focus();
            }
            break;
          case "Units":
            if (Units.current[index]) {
              Units.current[index].focus();
            }
            break;
          case "Qtys":
            if (Qtys.current[index]) {
              Qtys.current[index].focus();
            }
            break;
          case "SecUnits":
            if (SecUnits.current[index]) {
              SecUnits.current[index].focus();
            }
            break;
          case "Rates":
            if (Rates.current[index]) {
              Rates.current[index].focus();
            }
            break;
          case "Mrps":
            if (Mrps.current[index]) {
              Mrps.current[index].focus();
            }
            break;
          case "Amounts":
            if (Amounts.current[index]) {
              Amounts.current[index].focus();
            }
            break;
          case "TaxNames":
            if (TaxNames.current[index]) {
              TaxNames.current[index].focus();
            }
            break;
          case "Discs":
            if (Discs.current[index]) {
              Discs.current[index].focus();
            }
            break;
          case "Amounts":
            if (Amounts.current[index]) {
              Amounts.current[index].focus();
            }
            break;
      
          case "Adds":
            if (Adds.current[index]) {
              addTableRows()

              Adds.current[index].focus();
            }
            break;
          case "Deletes":
            if (Deletes.current[index]) {
            

              Deletes.current[index].focus();
            }
            break;
          default:
            break;
        }
      }, 0);
    }
  };
  const handler2 = (index, evnt, indo) => {
    if (evnt.key === "Enter") {
      const rowsInput = [...rowsData];

     
      if (index === "Code") {
        addTableRows();
        if (indo === rowsData.length - 1) {
          setFocusIndex(indo); 
        }
      }
      
       
    

      if (index === "Items") Items.current[indo].focus();
      else if (index === "Groups") Groups.current[indo].focus();
      else if (index === "Units") Units.current[indo].focus();
      else if (index === "Qtys") Qtys.current[indo].focus();
      else if (index === "SecUnits") SecUnits.current[indo].focus();
      else if (index === "Rates") Rates.current[indo].focus();
      else if (index === "Mrps") Mrps.current[indo].focus();
      else if (index === "Amounts") Amounts.current[indo].focus();
      else if (index === "TaxNames") TaxNames.current[indo].focus();
      else if (index === "Discs") Discs.current[indo].focus();
      else if (index === "Adds") {Adds.current[indo].focus()}
      else if (index === "Deletes") Deletes.current[indo].focus();

      evnt.preventDefault();
    }
  };

  return rowsData.map((data, index) => {
    

    const {
      IsDirectInvoice,
      CodeNo,
       Avail,
      ItemName,
      F_GroupMaster,
      F_ItemMaster,
      F_GodownMaster,
      Qty,
      F_UnitMaster,
      SecUnit,
      Rate,
      Disc,
      Amount
    } = data;

    return (
      <tr 
        key={index}
        style={{
          borderBottom: '1.5px solid black',
          backgroundColor: index % 2 === 0 ? '#f8f9fa' : 'white'
        }}
      >
        <td style={cellStyle}>{index + 1}</td>

        <td style={cellStyle}>
          <input
           onFocus={handleFocus}
            className="form-control"
            type="text"
            style={{ 
              width: "100px", 
              height: "36px",
              border: '1px solid #ced4da',
              borderRadius: '4px',
              textAlign: 'right'
            }}
            name="CodeNo"
            ref={el => (Code.current[index] = el)}
            onKeyPress={evnt => handler("Godowns", evnt, index)}
            value={CodeNo}
            onChange={evnt => handleChange(index, evnt)}
          />
        </td>

        <td style={cellStyle}>
          <select
          
            style={{ 
              width: "210px",
              height: "36px",
              border: '1px solid #ced4da',
              borderRadius: '4px',
              backgroundColor: 'white'
            }}
            ref={el => (Godowns.current[index] = el)}
            onKeyPress={evnt => handler("Items", evnt, index)}
            value={F_GodownMaster}
            name="F_GodownMaster"
            onChange={evnt => { handleChange(index, evnt); 
            // Items.current[index].focus(); 
            }}
            className="form-select"
          >
            <option value="-1" defaultValue label="Select" />
            {GodownMaster
              ? GodownMaster.map((option) => (
                <option
                  key={option.Id}
                  value={option.Id}
                  label={option.Name}
                />
              ))
              : null}
          </select>
        </td>
        <td style={{ ...cellStyle, display: 'none' }}>
          <select
          
            style={{ 
              width: "210px",
              height: "36px",
              border: '1px solid #ced4da',
              borderRadius: '4px',
              backgroundColor: 'white'
            }}
            ref={el => (Groups.current[index] = el)}
            onKeyPress={evnt => handler("Items", evnt, index)}
            value={F_GroupMaster}
            name="F_GroupMaster"
            onChange={evnt => { handleChange(index, evnt); Items.current[index].focus(); }}
            className="form-select"
          >
            <option value="-1" defaultValue label="Select" />
            {GroupMaster
              ? GroupMaster.map((option) => (
                <option
                  key={option.Id}
                  value={option.Id}
                  label={option.Name}
                />
              ))
              : null}
          </select>
        </td>
        <td style={cellStyle}>
          <select
            style={{ 
              width: "210px",
              height: "36px",
              border: '1px solid #ced4da',
              borderRadius: '4px',
              backgroundColor: 'white'
            }}
            ref={el => (Items.current[index] = el)}
            onKeyPress={evnt => handler("Colors", evnt, index)}
            value={ItemName}
            name="ItemName"
            onChange={evnt => { handleChange(index, evnt); 
            // Colors.current[index].focus(); 
            }}
            className="form-select"
          >
            <option value="-1" defaultValue label="Select" />
            {itemName
              ? itemName[index] && itemName[index].map((option) => (
                <option
                  key={option.Id}
                  id={option.IGST}
                  value={option.Id}
                  label={option.ItemName}
                />
              ))
              : null}
          </select>
        </td>
        <td style={cellStyle}>
          <select
          
            style={{ 
              width: "210px",
              height: "36px",
              border: '1px solid #ced4da',
              borderRadius: '4px',
              backgroundColor: 'white'
            }}
            ref={el => (Colors.current[index] = el)}
            onKeyPress={evnt => handler("Units", evnt, index)}
            value={F_ItemMaster}
            name="F_ItemMaster"
            onChange={evnt => { handleChange(index, evnt); 
            // Units.current[index].focus(); 
            }}
            className="form-select"
          >
            <option value="-1" defaultValue label="Select" />
            {ItemMaster
              ? ItemMaster.map((option) => (
                <option
                  key={option.Id}
                  value={option.Id}
                  label={option.Name}
                />
              ))
              : null}
          </select>
        </td>
        <td style={cellStyle}>
          <select
            style={{ 
              width: "80px",
              height: "36px",
              border: '1px solid #ced4da',
              borderRadius: '4px',
              backgroundColor: 'white'
            }}
            ref={el => (Units.current[index] = el)}
            onKeyPress={evnt => handler("Qtys", evnt, index)}
            value={F_UnitMaster}
            name="F_UnitMaster"
            onChange={evnt => { handleChange(index, evnt); 
            // Qtys.current[index].focus(); 
            }}
            className="form-select"
          >
            <option value={-1} defaultValue label="Select" />
            {UnitMaster
              ? UnitMaster.map((option) => (
                <option
                  key={option.Id}
                  value={option.Id}
                  label={option.Name}
                />
              ))
              : null}
          </select>
        </td>
        <td style={cellStyle}>
                  {Avail ? Avail : 0}
                </td>
        <td style={cellStyle}>
          <input
           onFocus={handleFocus}
            style={{ 
              width: "80px",
              height: "36px",
              border: '1px solid #ced4da',
              borderRadius: '4px',
              backgroundColor: 'white',
              textAlign: 'right'
            }}
            ref={el => (Qtys.current[index] = el)}
            onKeyPress={evnt => !IsStockIn ? handler("SecUnits", evnt, index) : onKeyPressHandler(evnt, index)}
            className="form-control"
            type="text"
            name="Qty"
            value={Qty}
            onChange={evnt => handleChange(index, evnt)}
          />
        </td>
        {!IsStockIn && (
          <td style={cellStyle}>
            <input
              onFocus={handleFocus}
              style={{ width: "60px", height: "36px", border: '1px solid #ced4da', borderRadius: '4px', backgroundColor: 'white', textAlign: 'right' }}
              ref={el => (SecUnits.current[index] = el)}
              onKeyPress={evnt => handler("Rates", evnt, index)}
              className="form-control"
              type="text"
              name="SecUnit"
              value={SecUnit !== "" && SecUnit != null ? SecUnit : ""}
              onChange={evnt => handleChange(index, evnt)}
            />
          </td>
        )}

        {!IsStockIn && <>
          <td style={cellStyle}>
            <input
             onFocus={handleFocus}
              style={{ 
                width: "60px",
                height: "36px",
                border: '1px solid #ced4da',
                borderRadius: '4px',
                backgroundColor: 'white'
              }}
              ref={el => (Rates.current[index] = el)}
              onKeyPress={evnt => handler("Deletes", evnt, index)}
              className="form-control"
              type="text"
              value={Rate}
              name="Rate"
              onChange={evnt => handleChange(index, evnt)}
            />
          </td>
          <td style={cellStyle}>
            <input
             onFocus={handleFocus}
              style={{ 
                width: "100px",
                height: "36px",
                border: '1px solid #ced4da',
                borderRadius: '4px',
                backgroundColor: 'white'
              }}
              ref={el => (Discs.current[index] = el)}
              onKeyPress={evnt => handler("Deletes", evnt, index)}
              className="form-control"
              type="text"
              value={Disc}
              name="Disc"
              onChange={evnt => handleChange(index, evnt)}
            />
          </td>

          <td style={cellStyle}>
            <input
             onFocus={handleFocus}
              style={{ 
                width: "80px",
                height: "36px",
                border: '1px solid #ced4da',
                borderRadius: '4px',
                backgroundColor: 'white'
              }}
              ref={el => (Amounts.current[index] = el)}
              onKeyPress={evnt => handler("Deletes", evnt, index)}
              className="form-control"
              type="text"
              value={Amount}
              name="Amount"
              onChange={evnt => handleChange(index, evnt)}
              disabled
            />
          </td>
        </>}

        <td style={cellStyle}>
          <button
            ref={el => (Deletes.current[index] = el)}
            onKeyPress={evnt => handler("Adds", evnt, index)}
            className="btn btn-outline-danger"
            style={{
              padding: '4px 8px',
              borderRadius: '4px'
            }}
            type="button"
            onClick={() => deleteTableRows(index)}
          >
            x
          </button>
        </td>
        <td style={cellStyle}>
          <button
            ref={el => (Adds.current[index] = el)}
            onClick={()=>addTableRows()}
            onKeyPress={evnt => handler("Code", evnt, index + 1)}
          
            type="button"
            className="btn btn-outline-success"
          >
            +
          </button>
        </td>
      </tr>
    );
  });
}

export default TableRows_pur;
